var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyDateBigIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 30,
    width: 30,
    fill: "#f1ab31",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 890",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M640.9 63.89999999999998c-141.4 0-256 114.6-256 256 0 19.6 2.2 38.6 6.4 56.9L0 768v64l64 64h128l64-64v-64h64v-64h64v-64h128l70.8-70.8c18.7 4.3 38.1 6.6 58.1 6.6 141.4 0 256-114.6 256-256S782.2 63.89999999999998 640.9 63.89999999999998zM384 512L64 832v-64l320-320V512zM704 320c-35.3 0-64-28.7-64-64 0-35.3 28.7-64 64-64s64 28.7 64 64C768 291.29999999999995 739.3 320 704 320z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyDateBigIcon);
export default __webpack_public_path__ + "static/media/keyDateBigIcon.1719d6c37041e65d59c42aa31975618b.svg";
export { ForwardRef as ReactComponent };